import Vue from 'vue';
import Router from 'vue-router';
import AuthGuard from './router/auth-guard';
import CheckRole from './router/check-role';
import Base from './views/Base';
import About from './views/About';
import Profile from './views/Profile';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Categories from './views/Categories';
import EmailLists from './views/EmailLists';
import EmailList from './views/EmailList';
import Emails from './views/Emails';
import Users from './views/Users';
import User from './views/User';
import Offer from './views/Offer';
import OfferList from './views/Offers';
import PmtaServers from './views/PmtaServers';
import PmtaServer from './views/PmtaServer';
import SmtpServers from './views/SmtpServers';
import SmtpServer from './views/SmtpServer';
import PmtaRelayGroups from './views/PmtaRelayGroups';
import PmtaRelayGroup from './views/PmtaRelayGroup';
import SmtpRelayGroups from './views/SmtpRelayGroups';
import SmtpRelayGroup from './views/SmtpRelayGroup';
import PmtaRelays from './views/PmtaRelays';
import PmtaRelay from './views/PmtaRelay';
import SmtpRelays from './views/SmtpRelays';
import SmtpRelay from './views/SmtpRelay';
import Messages from './views/Messages';
import Message from './views/Message';
import Tag from './views/Tag';
import Tags from './views/Tags';
import PmtaCampaign from './views/PmtaCampaign';
import PmtaCampaigns from './views/PmtaCampaigns';
import PmtaCampaignStatistics from './views/PmtaCampaignStatistics';
import SmtpCampaign from './views/SmtpCampaign';
import SmtpCampaigns from './views/SmtpCampaigns';
import SmtpCampaignStatistics from './views/SmtpCampaignStatistics';
import Unsubscribers from './views/Unsubscribers';
import Unsubscriber from './views/Unsubscriber'
import SpamDomains from './views/SpamDomains';
import SpamDomain from './views/SpamDomain';
import SpamEmails from './views/SpamEmails';
import SpamEmail from './views/SpamEmail';
import SpamMxs from './views/SpamMxs';
import SpamMx from './views/SpamMx';
import SocksProxy from './views/SocksProxy';
import SocksProxies from './views/SocksProxies';
import Link from './views/Link';
import Links from './views/Links';
import LinkGroup from './views/LinkGroup';
import LinkGroups from './views/LinkGroups';
import MailServiceSettings from './views/MailServiceSettings';
import MailServiceSetting from './views/MailServiceSetting';
import PmtaServerBalancers from './views/PmtaServerBalancers';
import Error_403 from './views/errors/Error_403';
import Error_404 from './views/errors/Error_404';
import Error_500 from './views/errors/Error_500';
import Dashboard from './views/Dashboard';
import ReputationProviders from './views/ReputationProviders';
import ReputationProvider from './views/ReputationProvider';
import PmtaRelaysReport from './views/ReportPmtaRelays';
import PmtaRelaysMailServiceReport from './views/ReportPmtaRelaysMailService';
import PmtaTroubleReport from './views/ReportPmtaTrouble';
import ProfitReport from './views/ReportProfit';
import ActivityReport from './views/ReportActivity';
import PmtaRelayIndicatorReport from './views/ReportPmtaRelayIndicators';
import PmtaRelayDeliverabilityReport from './views/ReportPmtaRelayDeliverability';
import MessageReport from './views/ReportMessage';
import MailProviderReport from './views/ReportMailProvider';
import EmailListReport from './views/ReportEmailList';
import Home from './views/Home';
import UuidDecoder from './views/UuidDecoder';
import EmailIdDecoder from './views/EmailIdDecoder';
import ToolHistory from './views/ToolHistory';
import UploadingLog from './views/UploadingLog';
import PmtaEmailTest from './views/PmtaEmailTest';
import PmtaEmailTests from './views/PmtaEmailTests';
import PmtaConfig from './views/PmtaConfig';
import PmtaConfigs from './views/PmtaConfigs';
import AppliedPmtaConfig from './views/AppliedPmtaConfig';
import AppliedPmtaConfigs from './views/AppliedPmtaConfigs';
import PmtaSpeed from './views/PmtaSpeed';
import PmtaSpeeds from './views/PmtaSpeeds';
import CampaignReport from './views/ReportCampaign';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {path: '/', redirect: {name: 'home'}, beforeEnter: AuthGuard},
        {path: '/login', name: 'login', component: Login, meta: {guest: true}},
        {path: '/register', name: 'register', component: Register, meta: {guest: true}},
        {
            path: '/home', component: Base, beforeEnter: AuthGuard,
            children: [
                {path: '', name: 'home', component: Home},
                {path: '/users', name: 'users', component: Users, beforeEnter: CheckRole},
                {path: '/users/create', name: 'usersCreate', component: User, beforeEnter: CheckRole},
                {path: '/users/:id/edit', name: 'usersEdit', component: User, beforeEnter: CheckRole},
                {path: '/email-list', name: 'emailLists', component: EmailLists},
                {path: '/email-list/create', name: 'emailListCreate', component: EmailList},
                {path: '/email-list/:id/edit', name: 'emailListManage', component: EmailList, props: true},
                {path: '/email-list/:id/emails', name: 'emails', component: Emails, props: true},
                {path: '/offers', name: 'offersList', component: OfferList},
                {path: '/offers/create', name: 'offersAdd', component: Offer},
                {path: '/offers/:id/edit', name: 'offersEdit', component: Offer, props: true},
                {path: '/tags', name: 'tags', component: Tags},
                {path: '/tags/create', name: 'tagCreate', component: Tag},
                {path: '/tags/:id/edit', name: 'tagEdit', component: Tag, props: true},
                {path: '/categories', name: 'categories', component: Categories, beforeEnter: CheckRole},
                {path: '/profile', name: 'profile', component: Profile},
                {path: '/about', name: 'about', component: About},
                {path: '/pmta-servers', name: 'pmtaServers', component: PmtaServers},
                {path: '/pmta-servers/:id/edit', name: 'pmtaServerEdit', component: PmtaServer, props: true},
                {path: '/pmta-servers/create', name: 'pmtaServerCreate', component: PmtaServer},
                {path: '/pmta-servers/:id/balancers', name: 'pmtaServerBalancers', component: PmtaServerBalancers},
                {path: '/smtp-servers', name: 'smtpServers', component: SmtpServers},
                {path: '/smtp-servers/:id/edit', name: 'smtpServerEdit', component: SmtpServer, props: true},
                {path: '/smtp-servers/create', name: 'smtpServerCreate', component: SmtpServer},
                {path: '/pmta-relay-groups', name: 'pmtaRelayGroups', component: PmtaRelayGroups},
                {path: '/pmta-relay-groups/:id/edit', name: 'pmtaRelayGroupEdit', component: PmtaRelayGroup, props: true},
                {path: '/pmta-relay-groups/create', name: 'pmtaRelayGroupCreate', component: PmtaRelayGroup},
                {path: '/smtp-relay-groups', name: 'smtpRelayGroups', component: SmtpRelayGroups},
                {path: '/smtp-relay-groups/:id/edit', name: 'smtpRelayGroupEdit', component: SmtpRelayGroup, props: true},
                {path: '/smtp-relay-groups/create', name: 'smtpRelayGroupCreate', component: SmtpRelayGroup},
                {path: '/pmta-relays', name: 'pmtaRelays', component: PmtaRelays},
                {path: '/pmta-relays/:id/edit', name: 'pmtaRelayEdit', component: PmtaRelay, props: true},
                {path: '/pmta-relays/by_server/:serverId', name: 'pmtaRelayFilter1', component: PmtaRelays, props: true},
                {path: '/pmta-relays/by_group/:groupId', name: 'pmtaRelayFilter2', component: PmtaRelays, props: true},
                {path: '/pmta-relays/by_relay/:relayId', name: 'pmtaRelayFilter3', component: PmtaRelays, props: true},
                {path: '/pmta-relays/create', name: 'pmtaRelayCreate', component: PmtaRelay},
                {path: '/smtp-relays', name: 'smtpRelays', component: SmtpRelays},
                {path: '/smtp-relays/:id/edit', name: 'smtpRelayEdit', component: SmtpRelay, props: true},
                {path: '/smtp-relays/by_server/:serverId', name: 'smtpRelayFilter1', component: SmtpRelays, props: true},
                {path: '/smtp-relays/by_group/:groupId', name: 'smtpRelayFilter2', component: SmtpRelays, props: true},
                {path: '/smtp-relays/create', name: 'smtpRelayCreate', component: SmtpRelay},
                {path: '/spam-domains', name: 'spamDomains', component: SpamDomains, beforeEnter: CheckRole},
                {path: '/spam-domains/create', name: 'spamDomainsCreate', component: SpamDomain, beforeEnter: CheckRole},
                {path: '/spam-domains/:id/edit', name: 'spamDomainsEdit', component: SpamDomain, beforeEnter: CheckRole},
                {path: '/spam-mxs', name: 'spamMxs', component: SpamMxs,beforeEnter: CheckRole},
                {path: '/spam-mxs/create', name: 'spamMxCreate', component: SpamMx, beforeEnter: CheckRole},
                {path: '/spam-emails', name: 'spamEmails', component: SpamEmails, beforeEnter: CheckRole},
                {path: '/spam-emails/create', name: 'spamEmailCreate', component: SpamEmail, beforeEnter: CheckRole},
                {path: '/spam-emails/:id/edit', name: 'spamEmailEdit', component: SpamEmail, beforeEnter: CheckRole},
                {path: '/messages', name: 'messages', component: Messages},
                {path: '/messages/:id/edit', name: 'messageEdit', component: Message, props: true},
                {path: '/messages/create', name: 'messageCreate', component: Message},
                {path: '/pmta-campaigns', name: 'pmtaCampaigns', component: PmtaCampaigns},
                {path: '/pmta-campaigns/:id/edit', name: 'pmtaCampaignEdit', component: PmtaCampaign, props: true},
                {path: '/pmta-campaigns/create', name: 'pmtaCampaignCreate', component: PmtaCampaign, props: true},
                {path: '/pmta-campaigns/:id/statistics', name: 'pmtaCampaignStatistics', component: PmtaCampaignStatistics, props: true},
                {path: '/smtp-campaigns', name: 'smtpCampaigns', component: SmtpCampaigns},
                {path: '/smtp-campaigns/:id/edit', name: 'smtpCampaignEdit', component: SmtpCampaign, props: true},
                {path: '/smtp-campaigns/create', name: 'smtpCampaignCreate', component: SmtpCampaign},
                {path: '/smtp-campaigns/:id/statistics', name: 'smtpCampaignStatistics', component: SmtpCampaignStatistics, props: true},
                {path: '/unsubscribers', name: 'unsubscribers', component: Unsubscribers},
                {path: '/unsubscribers/:id/edit', name: 'unsubscriberEdit', component: Unsubscriber},
                {path: '/unsubscribers/create', name: 'unsubscriberCreate', component: Unsubscriber},
                {path: '/mail-service-settings', name: 'mailServiceSettings', component: MailServiceSettings, beforeEnter: CheckRole},
                {path: '/mail-service-settings/create', name: 'mailServiceSettingCreate', component: MailServiceSetting, beforeEnter: CheckRole},
                {path: '/mail-service-settings/:id/edit', name: 'mailServiceSettingEdit', component: MailServiceSetting, beforeEnter: CheckRole},
                {path: '/dashboard', name: 'dashboard', component: Dashboard},
                {path: '/reputation-providers', name: 'ReputationProviderList', component: ReputationProviders},
                {path: '/reputation-providers/:id/edit', name: 'ReputationProviderEdit', component: ReputationProvider, props: true},
                {path: '/pmta-relays-report', name: 'pmtaRelaysReport', component: PmtaRelaysReport},
                {path: '/pmta-relays-mail-service-report', name: 'pmtaRelaysMailServiceReport', component: PmtaRelaysMailServiceReport},
                {path: '/pmta-trouble-report', name: 'pmtaTroubleReport', component: PmtaTroubleReport},
                {path: '/profit-report', name: 'profitReport', component: ProfitReport},
                {path: '/activity-report', name: 'activityReport', component: ActivityReport},
                {path: '/pmta-relay-indicator-report', name: 'pmtaRelayIndicatorReport', component: PmtaRelayIndicatorReport},
                {path: '/pmta-relay-deliverability-report', name: 'pmtaRelayDeliverabilityReport', component: PmtaRelayDeliverabilityReport},
                {path: '/message-report', name: 'messageReport', component: MessageReport},
                {path: '/mail-provider-report', name: 'mailProviderReport', component: MailProviderReport},
                {path: '/email-list-report', name: 'emailListReport', component: EmailListReport},
                {path: '/socks-proxies', name: 'socksProxies', component: SocksProxies},
                {path: '/socks-proxies/:id/edit', name: 'socksProxyEdit', component: SocksProxy, props: true},
                {path: '/socks-proxies/create', name: 'socksProxyCreate', component: SocksProxy},
                {path: '/socks-proxies/by_group/:groupId', name: 'socksProxyFilter1', component: SocksProxies, props: true},
                {path: '/links', name: 'links', component: Links},
                {path: '/links/:id/edit', name: 'linkEdit', component: Link, props: true},
                {path: '/links/create', name: 'linkCreate', component: Link},
                {path: '/links/by_group/:groupId', name: 'linkFilter1', component: Links, props: true},
                {path: '/link-groups', name: 'linkGroups', component: LinkGroups},
                {path: '/link-groups/:id/edit', name: 'linkGroupEdit', component: LinkGroup, props: true},
                {path: '/link-groups/create', name: 'linkGroupCreate', component: LinkGroup},
                {path: '/tools/uuid-decoder', name: 'uuidDecoder', component: UuidDecoder},
                {path: '/tools/email-id-decoder', name: 'emailIdDecoder', component: EmailIdDecoder},
                {path: '/tools/uploading-log', name: 'uploadingLog', component: UploadingLog},
                {path: '/tools/history', name: 'history', component: ToolHistory},
                {path: '/pmta-email-tests', name: 'pmtaEmailTests', component: PmtaEmailTests},
                {path: '/pmta-email-tests/create', name: 'pmtaEmailTestCreate', component: PmtaEmailTest, props: true},
                {path: '/pmta-configs', name: 'pmtaConfigs', component: PmtaConfigs},
                {path: '/pmta-configs/create', name: 'pmtaConfigCreate', component: PmtaConfig},
                {path: '/pmta-configs/:id/edit', name: 'pmtaConfigEdit', component: PmtaConfig, props: true},
                {path: '/applied-pmta-configs', name: 'appliedPmtaConfigs', component: AppliedPmtaConfigs},
                {path: '/applied-pmta-configs/create', name: 'appliedPmtaConfigCreate', component: AppliedPmtaConfig},
                {path: '/pmta-speeds', name: 'pmtaSpeeds', component: PmtaSpeeds},
                {path: '/pmta-speeds/create', name: 'pmtaSpeedCreate', component: PmtaSpeed},
                {path: '/pmta-speeds/:id', name: 'pmtaSpeedEdit', component: PmtaSpeed, props: true},
                {path: '/campaign-report', name: 'campaignReport', component: CampaignReport},
            ]
        },
        {path: '/page/error/500', name: '500', component: Error_500},
        {path: '/page/error/403', name: '403', component: Error_403},
        {path: '/page/error/404', name: '404', component: Error_404},
        {path: '*', redirect: '/'}
    ]
});
